import { Editor } from '@tiptap/core';
import React from 'react';

import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';
import { cn } from '@/utils';

interface BulletListMenuItemProps {
	editor: Editor | null;
	align: 'left' | 'center' | 'right'
}

const TextAlignItem = (props: BulletListMenuItemProps) => {
	const { editor, align } = props;

	if (!editor) {
		return null;
	}

	const icon = React.useMemo(() => {
		if (align === 'left') return 'textAlignLeft';
		else if (align === 'center') return 'textAlignCenter';
		return 'textAlignRight';
	}, [align])

	return (
		<Button
			onClick={() => editor.chain().focus().setTextAlign(align).run()}
			className={cn('w-6 h-6 text-brand-gray-2 [&>svg]:size-6 [&>svg]:reset p-0 [&>svg]:left-[0px]', 
				editor.isActive({ textAlign: align }) ? 'is-active' : ''
			)}
			size="icon"
			icon="left"
			variant="tetriary"
		>
			<Icon name={icon} size={24} />
		</Button>
	);
};

export { TextAlignItem };
